import {
  archiveKpiTemplate,
  createKpiTemplate,
  fetchAllKpiTemplates,
  fetchKpiTemplateById,
  updateKpiTemplate,
} from '../../routines/successplanTemplates/kpiTemplates';

const initialState = {
  selectedKpiTemplate: null,
  selectedKpiTemplateLoading: false,
  selectedKpiTemplateSuccess: true,
  kpiTemplateList: [],
  kpiTemplateListLoading: false,
  kpiTemplateListSuccess: false,
  kpiTemplateCreating: false,
  kpiTemplateCrateSuccess: false,
  kpiTemplateUpdating: false,
  kpiTemplateUpdateSuccess: false,
  kpiTemplateArchiving: false,
  kpiTemplateArchiveSuccess: false,
};

const successPlanTemplateKpiReducer = (state = initialState, action) => {
  switch (action.type) {
    case fetchAllKpiTemplates.TRIGGER:
      return {
        ...state,
        kpiTemplateCrateSuccess: false,
        kpiTemplateListLoading: true,
      };
    case fetchAllKpiTemplates.SUCCESS:
      return {
        ...state,
        kpiTemplateCrateSuccess: true,
        kpiTemplateListLoading: false,
        kpiTemplateList: action.payload?.data || [],
      };
    case fetchAllKpiTemplates.FAILURE:
      return {
        ...state,
        kpiTemplateCrateSuccess: false,
        kpiTemplateListLoading: false,
      };

    case fetchKpiTemplateById.TRIGGER:
      return {
        ...state,
        selectedKpiTemplateSuccess: false,
        selectedKpiTemplateLoading: true,
        selectedKpiTemplate: null,
      };
    case fetchKpiTemplateById.SUCCESS:
      return {
        ...state,
        selectedKpiTemplateSuccess: true,
        selectedKpiTemplateLoading: false,
        selectedKpiTemplate: action.payload?.data || null,
      };
    case fetchKpiTemplateById.FAILURE:
      return {
        ...state,
        selectedKpiTemplateSuccess: false,
        selectedKpiTemplateLoading: false,
        selectedKpiTemplate: null,
      };

    case createKpiTemplate.TRIGGER:
      return {
        ...state,
        kpiTemplateCreating: true,
        kpiTemplateCrateSuccess: false,
      };
    case createKpiTemplate.SUCCESS:
      return {
        ...state,
        kpiTemplateCreating: false,
        kpiTemplateCrateSuccess: true,
      };
    case createKpiTemplate.FAILURE:
      return {
        ...state,
        kpiTemplateCreating: false,
        kpiTemplateCrateSuccess: false,
      };

    case updateKpiTemplate.TRIGGER:
      return {
        ...state,
        kpiTemplateUpdating: true,
        kpiTemplateUpdateSuccess: false,
      };
    case updateKpiTemplate.SUCCESS:
      return {
        ...state,
        kpiTemplateUpdating: false,
        kpiTemplateUpdateSuccess: true,
      };
    case updateKpiTemplate.FAILURE:
      return {
        ...state,
        kpiTemplateUpdating: false,
        kpiTemplateUpdateSuccess: false,
      };

    case archiveKpiTemplate.TRIGGER:
      return {
        ...state,
        kpiTemplateArchiving: true,
        kpiTemplateArchiveSuccess: false,
      };
    case archiveKpiTemplate.SUCCESS:
      return {
        ...state,
        kpiTemplateArchiving: false,
        kpiTemplateArchiveSuccess: true,
      };
    case archiveKpiTemplate.FAILURE:
      return {
        ...state,
        kpiTemplateArchiving: false,
        kpiTemplateArchiveSuccess: false,
      };
    default:
      return state;
  }
};

export default successPlanTemplateKpiReducer;
